import { render, staticRenderFns } from "./SystemUsageCard.vue?vue&type=template&id=b8e61d98&"
import script from "./SystemUsageCard.vue?vue&type=script&lang=ts&"
export * from "./SystemUsageCard.vue?vue&type=script&lang=ts&"
import style0 from "./SystemUsageCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VRow})
